export const TECH_SUPPORT_CENTER_NAME = 'Technology Support Center';
export const TECH_SUPPORT_CENTER_EMAIL = 'techsupportcenter@nhaschools.com';
export const TECH_SUPPORT_CENTER_MAILTO = `mailto:${TECH_SUPPORT_CENTER_EMAIL}?subject=myNHA Access`;
